import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  normalizeLanguage,
} from './languages'

export const readStoredLanguage = () => {
  try {
    return normalizeLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY))
  } catch (e) {
    return DEFAULT_LANGUAGE
  }
}

export const storeLanguage = (language) => {
  try {
    window.localStorage.setItem(
      LANGUAGE_STORAGE_KEY,
      normalizeLanguage(language)
    )
  } catch (e) {
    // localStorage is unavailable in some privacy modes and tests.
  }
}
